module.exports = __webpack_public_path__ + "static/IMG_0383-88ac62dc170047e7ff355bcf6cdd5a88.jpg";